// Email Whitelist API
import { apiRequest } from './api';

export const WhitelistAPI = {
    /**
     * Get all whitelisted emails (admin only)
     */
    getWhitelist: (token: string) =>
        apiRequest<{ whitelist: any[] }>('/admin/whitelist', { token }),

    /**
     * Add email to whitelist (admin only)
     */
    addEmail: (data: { email: string, name?: string, notes?: string }, token: string) =>
        apiRequest<{ message: string, email: string }>('/admin/whitelist', {
            method: 'POST',
            token,
            body: JSON.stringify(data),
        }),

    /**
     * Bulk add emails to whitelist (admin only)
     * Handles rich data objects
     */
    bulkAddEmails: (items: any[], token: string) =>
        apiRequest<{ message: string; added: number; skipped: number; errors: string[] }>('/admin/whitelist?bulk', {
            method: 'POST',
            token,
            body: JSON.stringify({ items }),
        }),

    /**
     * Check if email is whitelisted (public)
     */
    checkWhitelist: (email: string) =>
        apiRequest<{ found: boolean; data: { name: string; phone: string; dob: string; gender: string } | null }>
            (`/auth/check_whitelist?email=${encodeURIComponent(email)}`),

    /**
     * Remove email from whitelist (admin only)
     */
    removeEmail: (email: string, token: string) =>
        apiRequest<{ message: string }>(`/admin/whitelist/${encodeURIComponent(email)}`, {
            method: 'DELETE',
            token,
        }),
};
